import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";
import { logout } from "src/store/authSlice";
import { Page } from "src/interfaces/Page";
import { RootState } from "../../store";
import { coursesSelector } from "../coursesSlice";
import {
  getAllLearnerCourses,
  getPopularCourses,
} from "src/actions/courseActions/learnerCourseActions";

const popularCoursesPaginationAdapter = createEntityAdapter<Page>();

const initialState = {
  pages: popularCoursesPaginationAdapter.getInitialState(),
  total: 0,
  totalItems: 0,
};

export const popularCoursesPaginationSlice = createSlice({
  name: "popularCourses/pagination",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPopularCourses.fulfilled, (state, { payload }) => {
      return {
        pages: popularCoursesPaginationAdapter.upsertOne(
          { ...state.pages },
          {
            id: parseInt(payload.currentPage),
            items: payload?.data?.map((item: any) => item.courses.id),
          }
        ),
        total: payload.pages,
        totalItems: payload.items,
      };
    });
    builder.addCase(logout.fulfilled, () => initialState);
  },
});

const adapterSelectors = popularCoursesPaginationAdapter.getSelectors(
  (s: RootState) => s.popularCoursesPagination.pages
);

export const popularCoursesPaginationSelectors = {
  pages: adapterSelectors,
  get: (state: RootState, page: number) =>
    adapterSelectors
      .selectById(state, page)
      ?.items.map((id: number) =>
        coursesSelector.coursesSelector.selectById(state, id)
      ) || [],
  totalPages: (state: RootState) => state.popularCoursesPagination.total,

  // total: (state: RootState) => state.continueLearning.totalItems,
};
